import PicNews from "./PicNews";

import moment from 'jalali-moment'
import RateBox from "./RateBox";
import NewsUpGreen from "../../assets/icon/NewsIcons/NewsUpGreen";
import DownRed from "../../assets/icon/NewsIcons/DownRed";
import React, { useState, useEffect } from 'react';

const PicNewses = ({ data,rateData }) => {
 

    const [currentIndex, setCurrentIndex] = useState(2);
    const [data2, setData2] = useState(data);
    useEffect(() => {
        const interval = setInterval(() => {
            console.log(555)
            console.log(data)
            console.log( data?.length)

            setCurrentIndex((prevIndex) => (prevIndex + 1) % data?.length);
            // setCurrentIndex((prevIndex) =>console.log(prevIndex + 1));
            console.log(currentIndex)
            //  setData2(data.filter((item, index) => index !== currentIndex)); // Remove the current index from the data
        }, 10000); // 10000 milliseconds = 10 seconds

        return () => clearInterval(interval); // Cleanup interval on component unmount
    }, [data?.length]);
    return (
        
            data?
            <div className="mx-[120px]  flex justify-start items-start xl:mx-[20px] md:flex-wrap" id="hasgreenBack">
            <div className="w-[24%] flex flex-col justify-between items-start md:w-[100%]">
                {data?.filter((item, index) => index !== currentIndex)?.map((news) => {
                    console.log(news?.article?.articleTittle)
                    return (
                        <div key={news?.article?.articleId} className="w-[100%] h-[200px] mt-[20px] first:mt-0">
                            <PicNews image={news?.article?.mainPicture} title={news?.article?.articleTittle}
                                time={moment(news?.article?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}
                               
                               navLink={"news/" + news?.category?.categorySlug + "/" + news?.article?.slug} />
                        </div>

                    )
                })}
            </div>
            <div className="w-[48%] mr-[2%] h-[420px] flex justify-center items-center md:w-[100%] md:mt-[15px] md:mr-[0px]">
                {
                    // console.log(currentIndex)&&
                    data[currentIndex]?
                        <PicNews
                            big = {true}
                            secondTitle={data[currentIndex]?.article?.secondTitle}
                            image={data[currentIndex]?.article?.mainPicture}
                            title={data[currentIndex]?.article?.articleTittle}
                             time={moment(data[currentIndex]?.article?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}
                            navLink={"news/" + data[currentIndex]?.category?.categorySlug + "/" + data[currentIndex]?.article?.slug}
                        />
                        :
                        null}
            </div>
            <div className="w-[24%] mr-[2%] h-[360px] rounded-b-2xl flex flex-col md:w-[100%] md:mt-[15px] md:mr-0">
            <div className="h-[50px] min-h-[50px] bg-nextColor  pr-[15px] flex items-center rounded-t-md">
                <p className="text-[17px] text-white font-IRANYekanBold lg:text-[13px]">شاخص های کلان اقتصادی</p>
            </div>
                {rateData?.map((rates) => (
                    <div key={rates.indexId} className=" rounded-b-[10px] first:mt-0">
                        <RateBox rateIcon={rates.title} rateTitle={rates.title} rate={rates.value} rateDate={rates.date} />
                    </div>
                ))}
                <div className="h-[2px] bg-[#E5E0EB]  pr-[15px] flex items-center rounded-b-md">
                
            </div>
                
            </div>
        </div>
            :
            null
        
     
    );
};

export default PicNewses;
